import enUS from 'antd/locale/en_US'
import _ from "lodash";
import {Country, Snapshot} from "../constants/enum";

const content = {
    App: {
        title: "FelixFusion",
        description: "Your Comprehensive AI Solution for Sourcing, Managing, and Submitting Goverment Contracts.",
    },
    Commons: {
        Intro: {
            title: "FelixFusion AI",
            description: "Your Comprehensive AI Solution for Sourcing, Managing, and Submitting Goverment Contracts.",
        },
        PendingRequest: {
            loading: "Receiving information from the server.",
        }
    },
    Layouts: {
        Dashboard: {
            menu: "Menu",
            dashboard: "Dashboard",
            opportunities: "Opportunities",
            bidSubmission: "Bid Submission",
            newSearchFilters: "New Search Filters",
            savedOpportunities: "Saved Opportunities",
            reportTenders: "Report Tenders",
            reportTenderBill: "Report Bill of Materials",
            helpCenter: "Help Center",
            decisionIntelligence: "Decision Intelligence",
            profile: "Profile",
            upgradePremium: "Upgrade to Premium",
            signOut: "Sign out",
            felixAIHistory: "Ask Alpha History",
            title: "FelixFusion",
            copyright: "© 2024 - 2025 | All rights reserved for FelixFusion."
        },
        Public: {
            copyright: "© 2024 - 2025 | All rights reserved for FelixFusion."
        }
    },
    Pages: {
        Dashboard: {
            title: "Powered by FelixFusion AI",
            description: "Choose your desired option",
            todayTenders: "Today Tenders",
            payments: "Current Plan",
            plan: "Plan",
            activation: "Activation",
            amount: "Amount",
            expiration: "Expiration",
        },
        InviteMember: {
            titleSuccess: "Successfully Add to Members",
            descriptionSuccess: "Welcome to FlexFusion",
            backOpportunities: "Back to opportunities",
            titleError: "Error Add to Members",
            descriptionError: "Welcome to FlexFusion",
            backPayment: "Back to payment",
        },
        Report: {
          Tender: {
              title: "Report Tenders",
              postedDate: "Posted Date",
              allTenders: "All Tenders",
              publishedTenders: "Published Tenders",
              hasFileTenders: "Has File Tenders",
              readableFileTenders: "Readable File Tenders",
              userAllTenders: "User All Tenders",
              userHasFileTenders: "User Has File Tenders",
              userReadableFileTenders: "User Readable File Tenders",
              userAnalyzedTenders: "User Analyzed Tenders",
              userEligibleTenders: "User Eligible Tenders",
              userFurtherInvestigationRequiredTenders: "User Further Investigation Required Tenders",
              userNotEligibleTenders: "User Not Eligible Tenders",
              userFelixFusionPickTenders: "User FelixFusion Picks Tenders",
          },
            Bill: {
                title: "Report Bill of Materials",
                postedDate: "Posted Date",
                modelNumbers: "Model Numbers",
                partNumbers: "Part Numbers",
                preferredVendors: "Preferred Vendors",
            }
        },
        Payment: {
            title: "Flexible Plans Tailored to Your Needs",
            description: "FelixFusion’s pricing is adjustable based on your company’s ROI.",
            choosePlan: "Choose plan",
            monthly: "Monthly billing",
            yearly: "Yearly billing (Save 10%)",
            basic: "Basic",
            basic1: "Search and Match capabilities",
            basic2: "Access to AI Profile",
            basic3: "Basic customer support",
            premium: "Premium",
            premium1: "All features from the Basic Plan",
            premium2: "Daily Opportunity by Email",
            premium3: "Decision Intelligence for strategic planning",
            premium4: "Access to AI features for proposal writing",
            premium5: "Priority customer support",
            prime: "Prime",
            prime1: "All features from the Premium Plan",
            prime2: "White-glove service for proposal drafting",
            prime3: "White-glove service for Compliance matrix",
            prime4: "AI Proposal Generation",
            prime5: "Dedicated account manager",
            whiteGloveService: "White Glove Service",
            credit: "Credit",
            creditPackageSize: "Credit Package Size",
            contactUs: "Contact Us",
            awardedContractAmount: "1 credit + 5% of awarded contract amount",
            popular: "Popular",
            x3: "3 X (Save 5%)",
            x6: "6 X (Save 10%)",
            x9: "9 X (Save 15%)",
            payStripe: "Pay with Stripe",
            frequently: "Frequently asked questions",
            question1: "What is FelixFusion and how can it help my business?",
            answer1: "FelixFusion is an AI-driven multi-agent system that automates the entire government tendering process for SMEs. Our platform leverages advanced artificial intelligence and operations research algorithms to help you discover opportunities, predict success, optimize bids, and ensure compliance—making government contracts accessible like never before.",
            question2: "How does the Predictive Tender Success Index (PTSI) work?",
            answer2: "FelixFusion is an AI-driven multi-agent system that automates the entire government tendering process for SMEs. Our platform leverages advanced artificial intelligence and operations research algorithms to help you discover opportunities, predict success, optimize bids, and ensure compliance—making government contracts accessible like never before.",
            question3: "Can FelixFusion optimize my bidding strategy?",
            answer3: "You can ask FelixFusion anything you would ask a human assistant, such as weather updates, news headlines, restaurant recommendations, and more.",
            question4: "How does FelixFusion ensure compliance with tender requirements?",
            answer4: "FelixFusion is an AI-driven multi-agent system that automates the entire government tendering process for SMEs. Our platform leverages advanced artificial intelligence and operations research algorithms to help you discover opportunities, predict success, optimize bids, and ensure compliance—making government contracts accessible like never before.",
            question5: "What if I lack the resources to execute an opportunity?",
            answer5: "FelixFusion is an AI-driven multi-agent system that automates the entire government tendering process for SMEs. Our platform leverages advanced artificial intelligence and operations research algorithms to help you discover opportunities, predict success, optimize bids, and ensure compliance—making government contracts accessible like never before.",
            successTitle: "Thank you for your purchase!",
            successDescription: "Your order has been received and is currently being processed. You will receive an email confirmation with your order details shortly.",
            successButton1: "Manage subscription",
            successButton2: "Start new search",
            errorTitle: "Payment Error",
            errorDescription: "Thank you for completing your payment. This is a confirmation that we have just received your secure online payment. we sent you an email with a copy of your detailed invoice. Thank you!",
            errorButton: "Back to Payment",
            buy: "Buy Subscription",
        },
        Opportunities: {
            title: "Opportunities",
            Filter: {
                title: "Filter By",
                useProfileFilter: "Use profile filter",
                source: "Default Source",
                activeOnly: "Active Only",
                inactiveOnly: "Inactive Only",
                dueDate: "Due Date",
                postedDate: "Posted Date",
                solicitationNumber: "Solicitation Number",
                solicitationNumberPlaceholder: "Ex: W9132T21R0002",
                buyerInclude: "Buyer(s) Include",
                buyerExclude: "Buyer(s) Exclude",
                buyerPlaceholder: "Ex: Dept. of defense",
                naicsCode: "NAICS Code(s)",
                naicsCodePlaceholder: "Ex: 513210",
                pscCode: "PSC Code(s)",
                pscCodePlaceholder: "Ex: 2210",
                gsinCode: "GSIN Code(s)",
                gsinCodePlaceholder: "Ex: 2210",
                unspscCode: "UNSPSC Code(s)",
                unspscCodePlaceholder: "Ex: 2210",
                noticeType: "Notice Type(s)",
                noticeTypePlaceholder: "Ex: Solicitation",
                setAsideCode: "Set Aside Code(s)",
                setAsideCodePlaceholder: "Ex: 8A",
                agreementCode: "Agreement Code(s)",
                agreementCodePlaceholder: "Ex: 8A",
                applyFilter: "Apply Filter(s)",
                clearFilter: "Clear",
                copyClipboard: "copy link to clipboard",
                noReadableFiles: "no readable files",
                precompiled: "Pre-compiled",
                analysis: "Analyzed",
                partOrModelNumber: 'has Part/Model Number',
            },
            Search: {
                searchPlaceholder: "Search in all",
                searchButton: "Search",
                export: "Export",
                filter: "Filter",
                postedDate: "Posted Date",
                createSchedule: "Create Schedule",
                selectOpportunity: "Select Opportunity",
                basicSearch: "User Profile Search",
                felixFusionPicks: "FelixFusion Picks",
                askAI: "Ask AI",
                buyer: "Buyer",
                dueDate: "Due",
                publishDate: "Publish Date",
                pvb: "PVB",
                pts: "PTS",
                naics: "NAICS",
                noticeType: "Notice Type",
                psc: "PSC",
                gsin: "GSIN",
                unspsc: "UNSPSC",
                setAside: "Set Aside",
                withoutSetAside: "Without Set Aside Code",
                agreement: "Agreement",
                withoutAgreement: "Without Agreement Code",
            },
            Tender: {
                active: 'Active',
                expired: 'Expired',
                askAlpha: 'Ask Alpha',
                askAlphaDefaultMessage: 'Hello! How can I help you today?',
                askPlaceholder: 'Ask Alpha anything ...',
                addToCRM: 'Add to CRM',
                runIntelligence: 'Run Intelligence',
                solicitationNumber: 'Solicitation Number',
                exportPDF: 'Export to PDF',
                proposalDOC: 'Generate Proposal',
                summary: 'Summary',
                contractAuthority: 'Contract Authority',
                estimateValue: 'Estimate Value',
                service: 'Service',
                days: 'Days',
                overview: 'Overview',
                naics: "NAICS",
                psc: "PSC",
                gsin: "GSIN",
                unspsc: "UNSPSC",
                noticeType: "Notice Type",
                publishDate: "Publish Date",
                dueDate: "Due",
                projectScopeWorkService: 'Project Scope of Work or Service',
                billOfMaterials: 'Bill of Materials',
                item: 'Item',
                partNumber: 'Part Number',
                quantity: 'Quantity',
                preferredVendor: 'Preferred Vendor',
                soleSource: 'Sole Source',
                alternateVendor: 'Alternate Vendor',
                modelNumber: 'Model Number',
                cageCode: 'CAGE Code',
                technicalSpecification: 'Technical Specification',
                additionalTechnicalInformation: 'Additional Technical Information',
                vendorSelectionCriteria: 'Vendor Selection Criteria',
                delivery: 'Delivery',
                deliveryAddress: 'Delivery Address',
                placePerformance: 'Place of Performance',
                buyer: 'Buyer',
                nameAgency: 'Name of the Agency',
                subTierName: 'Sub-Tier Name',
                officeName: 'Office Name',
                contactInformation: 'Contact Information',
                name: "Name",
                email: "Email",
                phone: "Phone",
                buyerWebsite: 'Buyer Website',
                inspectionTest: 'Inspection & Test',
                specificTestsRequested: 'Specific Tests Requested',
                inspectionsRequested: 'Inspections Requested',
                additionalRequiredSteps: 'Additional Required Steps',
                compliance: 'Compliance',
                setAsideInformation: 'Set-Aside Information',
                agreementInformation: 'Agreement Information',
                requiredCertificates: 'Required Certificates',
                warrantyDetails: 'Warranty Details',
                guaranteeDetails: 'Guarantee Details',
                legalClauses: 'Legal Clauses',
                clauseNumber: 'Clause Number',
                clauseTitle: 'Clause Title',
                description: 'Description',
                commercialInsight: 'Commercial Insight',
                estimatedPrice: 'Estimated Price',
                estimatedPricePartOne: 'A competitive total offer near',
                estimatedPricePartTwo: 'would align with market standards while ensuring profitability.',
                docs: 'Docs',
                tenderFiles: 'Tender Files',
                documentName: 'Document Name',
                documentDownload: 'Download',
                documentSize: "Document Size",
                fileFormat: "You can only upload TXT/PDF/DOC file!",
                fileSize: "You file must smaller than 5MB!",
                upload: "Upload to FelixFusion",
                uploadDescription: "You can add prompts after uploading. TXT/PDF/DOC",
                bidSubmissionFormat: 'Bid Submission Format',
                requirement: 'Requirement',
                decisionIntelligence: 'Decision Intelligence (Beta)',
                proposal: 'Proposal',
                eligibilityReview: 'Eligibility Review',
                overallStatus: 'Overall Status',
                missingDocumentTitle: 'Upload Missing Documents',
                missingDocumentDecisionIntelligenceDescription: 'Decision Intelligence did not run due to missing documents. Please upload your documents in the Docs tab and click \'Run Intelligence\'.',
                missingDocumentProposalDescription: 'Proposal did not run due to missing documents. Please upload your documents in the Docs tab and click \'Run Intelligence\'.',
                recommendations: 'Recommendations',
                userStatus: 'User Status',
                reference: 'Reference',
                strategicAlignment: '1. Strategic Alignment',
                relevanceExpertise: 'Relevance of Expertise',
                valueProposition: 'Value Proposition',
                outcomeAdvantage: 'Outcome Advantage',
                opportunityPrioritization: '2. Opportunity Prioritization',
                setAsideOpportunity: 'Set-Aside Opportunity',
                agreementOpportunity: 'Agreement Opportunity',
                evaluationFocus: 'Evaluation Focus',
                timelineSubmission: 'Timeline for Submission',
                riskMitigation: '3. Risk Mitigation',
                complianceRisks: 'Compliance Risks',
                deliveryRisks: 'Delivery Risks',
                financialRisks: 'Financial Risks',
                complianceCertification: '4. Compliance & Certification',
                certifications: 'Certifications',
                documentation: 'Documentation',
                regulatory: 'Regulatory',
                competitivePositioning: '5. Competitive Positioning',
                keyDifferentiators: 'Key Differentiators',
                smallBusinessAdvantage: 'Small Business Advantage',
                actionPlanForYourBusiness: '6. Action Plan for Your Business',
                alignStrengthsWithRequirements: '1. Align Strengths with Requirements',
                optimizeProposalDocumentation: '2. Optimize Proposal Documentation',
                confirmSAMRegistration: '3. Confirm SAM Registration',
                refinePricingStrategy: '4. Refine Pricing Strategy',
                logisticsPlanning: '5. Logistics Planning',
                proactiveCommunication: '6. Proactive Communication',
                toBeProvidedByContractor: '[TO BE PROVIDED BY CONTRACTOR]',
                coverPage: 'Cover Page',
                tenderTitle: 'Tender Title',
                buyerInformation: 'Buyer Information',
                agencyName: 'Agency Name',
                address: 'Address',
                pointOfContact: 'Point of Contact',
                contractorInformation: 'Contractor Information: [TO BE FILLED BY CONTRACTOR]',
                submissionDeadline: 'Submission Deadline',
                companyIntroduction: 'Company Introduction',
                setAsideQualification: 'Set-Aside Qualification',
                agreementQualification: 'Agreement Qualification',
                scopeOfWork: 'Scope of Work',
                projectOverview: 'Project Overview',
                specificDeliverables: 'Specific Deliverables',
                unitPrice: 'Unit Price',
                deliveryTime: 'Delivery Time',
                technicalSpecificationsCompliance: 'Technical Specifications & Compliance',
                standardsAndCompliance: 'Standards and Compliance',
                deliveryInspectionDetails: 'Delivery & Inspection Details',
                placeOfPerformance: 'Place of Performance',
                inspections: 'Inspections',
                warrantyGuarantee: 'Warranty Guarantee',
                requirements: 'Requirements',
                type: 'Type',
                appendix: 'Appendix',
                requiredDocumentation: 'Required Documentation [to be inserted by contractor]',
                notes: 'Notes',
                submissionMethodFormat: 'Submission Method & Format',
                method: 'Method',
                format: 'Format',
                evaluationAwardCriteria: 'Evaluation & Award Criteria',
                evaluation: 'Evaluation',
                scoring: 'Scoring',
                awardTimeline: 'Award Timeline',
                instructionsForUse: 'Instructions for Use',
                loadingTender: 'Please wait for a few minutes and do not perform any operations until the page is fully loaded.',
                search: 'Search',
            },
        },
        AskHistory: {
            title: "Felix Insight History",
            search: 'Search',
        },
        SavedOpportunities: {
            title: "Saved Opportunities",
        },
        SignIn: {
            title: "Sign in",
            google: "Continue with Google",
            signIn: "Sign in",
            signUp: "Create account",
            or: "OR",
            email: "Email",
            emailPlaceholder: "Enter your mail",
            password: "Password",
            passwordPlaceholder: "type your password here...",
            forgotPassword: "Forgot Password?",
            otp: "OTP",
            enableOTP: "Enable OTP",
            sendOTP: "Send OTP Code",
            submit: "Sign in with FelixFusion",
        },
        ResetPassword: {
            title: "Reset your password",
            email: "Email",
            emailPlaceholder: "Enter your mail",
            password: "Password",
            passwordPlaceholder: "type your password here...",
            passwordConfirm: "Confirm Password",
            passwordConfirmPlaceholder: "type confirm your password here...",
            resetPassword: "Reset Password",
            signIn: "Back to Sign In",
            resetPasswordNotice: "Your password has been successfully reset.",
            sendEmailNotice: "If that email address is in our database, we will send you an email to reset your password.",
            gmail: "Open Gmail",
            outlook: "Open Outlook",
            yahoo: "Open Yahoo!",
        },
        Profile: {
            title: "Profile",
            myAccount: "My Account",
            felixTechnology: "Felix Technology",
            overview: "Overview",
            classifications: "Preferences",
            aiFiles: "AI Questions",
            members: "Team",
            paymentHistory: "Payments",
            deleteAccount: "Delete account",
            MyAccount: {
                title: "My Account",
                information: "Personal Information",
                uploadTitle: "Upload New Image",
                uploadDescription: "At least 800x800 px recommended. JPG or PNG is allowed",
                avatar: "Avatar",
                avatarFormat: "You can only upload JPG/PNG file!",
                avatarSize: "Avatar image must smaller than 2MB!",
                firstName: "First Name",
                lastName: "Last Name",
                email: "Email",
                password: "Old Password",
                newPassword: "New Password",
                newPasswordConfirm: "Confirm New Password",
                passwordDescription: "Minimum 8 characters",
                otp: "OTP",
                enableOTP: "Enable OTP",
                saveChange: "Save change",
                cancel: "Cancel",
            },
            Overview: {
                title: "Overview",
                organizationName: "Organization Name",
                organizationNamePlaceholder: "Type your organization name here",
                yourWebsite: "Your Website",
                yourWebsitePlaceholder: "EX: domain.com",
                description: "Description",
                descriptionPlaceholder: "A short description about your organization",
                uei: "UEI",
                ueiPlaceholder: "Type your UEI here",
                cageCode: "CAGE Code",
                cageCodePlaceholder: "Type your CAGE Code here",
                contactInformation: "Contact Information",
                firstName: "First Name",
                firstNamePlaceholder: "Type your First Name here",
                lastName: "Last Name",
                lastNamePlaceholder: "Type your Last Name here",
                email: "Email",
                emailPlaceholder: "Type your Email here",
                address: "Address",
                address1: "Address Line 1",
                address1Placeholder: "Type your address line 1 here",
                address2: "Address Line 2",
                address2Placeholder: "Type your address line 2 here",
                city: "City",
                cityPlaceholder: "Type your city here",
                state: "State / Province",
                statePlaceholder: "Type your state here",
                zipCode: "Postal / ZIP Code",
                zipCodePlaceholder: "Type your postal/zip code here",
                country: "Country",
                countryPlaceholder: "Select your country",
                saveChange: "Save change",
                cancel: "Cancel",
            },
            Classifications: {
                title: "Preferences",
                naicsCode: "NAICS Code(s)",
                naicsCodePlaceholder: "Ex: 513210",
                pscCode: "PSC Code(s)",
                pscCodePlaceholder: "Ex: 2210",
                gsinCode: "GSIN Code(s)",
                gsinCodePlaceholder: "Ex: 2210",
                unspscCode: "UNSPSC Code(s)",
                unspscCodePlaceholder: "Ex: 2210",
                noticeType: "Notice Type(s)",
                noticeTypePlaceholder: "Ex: Solicitation",
                setAsideCode: "Set Aside Code(s)",
                setAsideCodePlaceholder: "Ex: 8A",
                agreementCode: "Agreement Code(s)",
                agreementCodePlaceholder: "Ex: 8A",
                opportunity: "Preferred Opportunities",
                buyer: "Buyer Preferences",
                buyerIncludePlaceholder: "Buyer(s) Include",
                buyerExcludePlaceholder: "Buyer(s) Exclude",
                job: "Are you manufacturer or trader?",
                companySize: "What is the size of your company?",
                tenderType: "Type of preferred tenders",
                saveChangeTitle: "Changes saved successfully",
                saveChangeDescription: "Your updates are being processed and will be reflected in our intelligence flow within 24 hours.",
                saveChange: "Save change",
                cancel: "Cancel",
            },
            AIFiles: {
                title: "AI Questions",
                aiFileFormat: "You can only upload TXT/PDF/DOC file!",
                aiFileSize: "You file must smaller than 10MB!",
                upload: "Upload to FelixFusion",
                uploadDescription: "You can add prompts after uploading. TXT/PDF/DOC",
                uploadRecently: "Recently Uploaded",
                mimeType: "File Type",
                originalName: "Document Name",
                size: "File Size",
                budget: "What is your budget for tender opportunities?",
                grant: "How much grant funding are you seeking?",
                certifications: "Do you have any specific certifications?",
                certificationsPlaceholder: "Type your certificate name here",
                suggestion: "Suggestions",
                pscCode: "PSC Code(s)",
                pscCodePlaceholder: "Ex: 2210",
                pscCodeSelected: "Selected PSC Codes (max 50 codes)",
                pscCodeSuggested: "Suggested PSC Codes",
                gsinCode: "GSIN Code(s)",
                gsinCodePlaceholder: "Ex: 2210",
                gsinCodeSelected: "Selected GSIN Codes (max 50 codes)",
                gsinCodeSuggested: "Suggested GSIN Codes",
                unspscCode: "UNSPSC Code(s)",
                unspscCodePlaceholder: "Ex: 2210",
                unspscCodeSelected: "Selected UNSPSC Codes (max 50 codes)",
                unspscCodeSuggested: "Suggested UNSPSC Codes",
                noticeType: "Notice Type(s)",
                noticeTypePlaceholder: "Ex: Solicitation",
                noticeTypeSuggested: "Suggested Notice Type(s)",
                setAsideCode: "Set Aside Code(s)",
                setAsideCodePlaceholder: "Ex: 8A",
                setAsideCodeSuggested: "Suggested Set Aside Code(s)",
                agreementCode: "Agreement Code(s)",
                agreementCodePlaceholder: "Ex: 8A",
                agreementCodeSuggested: "Suggested Agreement Code(s)",
                naicsCodeSelected: "Selected NAICS Codes (max 50 codes)",
                naicsCodeSuggested: "Suggested NAICS Codes",
                naicsCode: "NAICS Code(s)",
                naicsCodePlaceholder: "Ex: 513210",
                buyerInclude: "Buyer Include",
                buyerExclude: "Buyer Exclude",
                buyerIncludePlaceholder: "Buyer(s) Include",
                buyerExcludePlaceholder: "Buyer(s) Exclude",
                buyersIncludeSelected: "Selected Buyers Include",
                buyerIncludeSuggested: "Suggested Buyers Include",
                buyersExcludeSelected: "Selected Buyers Exclude",
                buyerExcludeSuggested: "Suggested Buyers Exclude",
                save: "Save and Update Profile",
                saveChange: "Save change",
                cancel: "Cancel",
            },
            Members: {
                title: "Members",
                members: "members",
                admin: "Admin",
                email: "Email",
                emailPlaceholder: "EX: info@domain.com",
                emailHelp: "You can only use your organization email.",
                inviteMember: "Invite Member",
                inviteNewMember: "Invite New Member",
                addMember: "Add Member",
            },
            PaymentHistory: {
                title: "Payment History",
                plan: "Plan",
                activation: "Activation",
                amount: "Amount",
                expiration: "Expiration",
                backOpportunities: "Back to opportunities",
            },
            DeleteAccount: {
                title: "We’re sorry to see you go :(",
                description: "Warning: Deleting your account will permanently remove all of your data and cannot be undone. This includes your profile, AI chat histories, Contracts, and any other information associated with your account. Are you sure you want to proceed with deleting your account?",
                password: "Your Password",
                passwordPlaceholder: "Password",
                delete: "Delete my account",
                cancel: "Cancel",
            },
        },
        SignUp: {
            title: "Welcome to FlexFusion",
            google: "Continue with Google",
            signIn: "Sign in",
            signUp: "Create account",
            or: "OR",
            firstName: "First Name",
            firstNamePlaceholder: "John",
            lastName: "Last Name",
            lastNamePlaceholder: "Doe",
            email: "Email",
            emailPlaceholder: "Enter your mail",
            password: "Password",
            passwordPlaceholder: "type your password here...",
            passwordDescription: "At least 8 characters",
            termsOfService: "Terms of Service",
            agree: "Agree",
            disagree: "Disagree",
            termsOfService_1: "By creating an account, you agree to our",
            termsOfService_2: "Terms of Service and Privacy",
            termsOfService_3: "& Cookie Statement.",
            submit: "Join FlexFusion",
        },
        NotFound: {
            title: "Not Found",
            description: "Unfortunately, the page you requested was not found.",
        },
        Forbidden: {
            title: "Not Authorization",
            description: "Unfortunately, you do not have permission to access this page.",
        },
    },
    Validation: {
        required: "Required !",
        length: "Length",
        pattern: "Does not match the pattern",
        number: "can only be a number",
        string: "can only be a string",
        website: "invalid domain",
        min: "Min",
        max: "Max",
        invalidEmail: "Invalid email address",
        passwordConfirm: "The new password that you entered do not match!",

    },
    Share: {
        edit: "Edit",
        add: "Add",
        delete: "Delete",
        view: "View",
        save: "Save",
        cancel: "Cancel",
        search: "Search",
        yes: "Yes",
        no: "No",
        row: "Row",
        noResults: "No Search Results Found",
        noAsk: "No Ask Alpha Found",
        operation: "Operation",
        prev: "Prev",
        next: "Next",
        download: "Download",
        pleaseSelect: "Please Select ...",
        selectDate: "Select Date",
        paginationShowTotal: "Show total",
        deleteConfirmMemberTitle: "Are you sure to delete member?",
        deleteConfirmTitle: "Are you sure to delete the desired item?",
        deleteConfirmOk: "Ok",
        deleteConfirmCancel: "Cancel",
        attachment: "File upload location",
        attachmentDescription: "Attach your files by clicking or dropping them in this section.",
        loading: "Loading ...",
        backHome: "Back to home",
        new: "new",
        usd: "USD",
        notSpecified: "Not specified",
    },
    Message: {
        SIGN_IN_PROFILE: "You are logged in to your account.",
        SIGN_OUT_PROFILE: "You are logged out of your account.",
        UPDATE_PROFILE: "Your account information has been successfully change.",
        CAPTCHA_INVALID: "Captcha invalid",
        UPLOAD_SUCCESS: "File uploaded successfully",
        UPLOAD_ERROR: "There was an error loading the file",
        CHANGE_SUCCESS: "The changes were applied successfully",
        DELETE_MEMBER: "Member delete successfully",
        ADD_MEMBER: "Member add successfully",
        INVITE_MEMBER: "Invite Member successfully",
        DELETE_ACCOUNT: "Delete account successfully",
        OTP_SUCCESS: "OTP Code send to email successfully",
        USER_OTP_IS_DISABLE: "OTP disabled for this email",
        OTP_CODE_SENT: "OTP Code already sent (It is not possible to send until 10 minutes)",
        COPY_TO_CLIPBOARD: "Copy link to clipboard",
        File_NOT_FOUND: "File Not Found",
        STRIPE_ERROR: "Could not connect to stripe",
        "ThrottlerException: Too Many Requests": "Too Many Requests",
        "Unauthorized": "The entered information is not verified.",
        "Not Found": "There is no such record.",
        "duplicate email user": "duplicate email address",
        "reset password token invalid": "reset password token invalid",
        "file is not uploaded": "file is not uploaded",
        "old password invalid": "old password invalid",
        "remove user invalid": "It is not possible to delete this member",
        "add user invalid": "It is not possible to add this user",
        "organization name invalid": "Organization Name invalid",
        "password invalid": "Your Password invalid",
        "It is impossible to invite this user": "It is impossible to invite this user",
    },
    Enum: {
        Plan: {
            FELIX_BASIC: "Felix Basic",
            FELIX_PREMIUM: "Felix Premium",
            FELIX_PRIME: "Felix Prime",
        },
        Member: {
            MEMBER: "Member",
            INVITE: "Invite",
        },
        Job: {
            MANUFACTURER: 'I’m a Manufacturer',
            TRADER: 'I’m a Trader',
        },
        CompanySize: {
            ZERO_TEN: '0-10',
            TEN_FIFTY: '10-50',
            FIFTY_PLUS: '+50',
        },
        TenderType: {
            GOODS: 'Goods',
            SERVICE: 'Service',
            BOTH: 'Both',
        },
        Budget: {
            MINUS_FIVE_HUNDRED: 'Less than 500k',
            FIVE_HUNDRED_ONE_MILLION: '500k-1M',
            ONE_MILLION_PLUS: 'More than 1M',
        },
        Grant: {
            MINUS_FIVE_HUNDRED: 'Less than 500k',
            FIVE_HUNDRED_ONE_MILLION: '500k-1M',
            ONE_MILLION_PLUS: 'More than 1M',
        },
        Source: {
            US_TENDER: 'US Tenders',
            US_GRANT: 'US Grants',
            EUROPE_TENDER: 'Europe Tenders',
            EUROPE_GRANT: 'Europe Grants',
            CANADA_TENDER: 'Canada Tenders',
            CANADA_GRANT: 'Canada Grants',
        },
        Branch: {
            TENDERS: 'Tenders',
            GRANTS: 'Grants',
        },
        Snapshot: {
            'Solicitation Name': 'Solicitation Name',
            'Issue Date': 'Issue Date ',
            'Enduser Name': 'End-user Name',
            'Enduser Address': 'End-user Address',
            'Submission Deadline': 'Submission Deadline',
            'Questionnaire Deadline': 'Questionnaire Deadline',
            'Submission Method': 'Submission Method',
            'Type of Purchase': 'Type of purchase',
            'Goods Description': 'Goods Brief description of goods to supply',
            'Training': 'Training',
            'Installation': 'Installation',
            'Preventive Maintenance': 'Preventive Maintenance',
            'Spare Part Kit': 'Spare Part Kit',
            'Any Standard/Approval': 'Any Satandard/Approval',
            'Warranty': 'Warranty',
            'Evaluation Method': 'Evaluation Method',
            'Requested Delivery Date': 'Requested Delivery Date',
            'Delivery Term': 'Delivery Term',
            'Delivery Location': 'Delivery Location',
            'Payment Term': 'Payment Term',
            'Notes': 'Notes',
        },
        Country: {
            CANADA_TENDER: 'Canada Profile',
            EUROPE_TENDER: 'Europe Profile',
            US_TENDER: 'USA Profile',
        },
    }
}

export default _.merge(enUS, content);
